import React from "react";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  accessCard: state.accessCard.item
});

class AccessCardSubmitted extends React.Component {
  render() {
    const { accessCard } = this.props;
    if (!accessCard.id) {
      return "Ingen informasjon/Sesjon er utløpt";
    }
    return (
      <React.Fragment>
        <div className="page-header">
          <h1>Bestilling innsendt</h1>
        </div>

        <table className="table table-striped">
          <thead>
            <tr>
              <th>Innsendt informasjon</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Bestiller</th>
              <td>{accessCard.orderer}</td>
            </tr>
            <tr>
              <th>Fornavn</th>
              <td>{accessCard.firstname}</td>
            </tr>
            <tr>
              <th>Etternavn</th>
              <td>{accessCard.surname}</td>
            </tr>
            <tr>
              <th>Adgangsnivåer</th>
              <td>
                {accessCard.access_levels.map(accessLevel => (
                  <li key={`access_level-${accessLevel.id}`}>
                    {accessLevel.name}
                  </li>
                ))}
              </td>
            </tr>
            <tr>
              <th>PIN</th>
              <td>{accessCard.pin}</td>
            </tr>
            <tr>
              <th>Notis</th>
              <td>{accessCard.note}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps)(AccessCardSubmitted);



// WEBPACK FOOTER //
// ./src/components/AccessCardSubmitted.js